import { omit } from "lodash"
import { TakeableChannel } from "redux-saga"
import { put, takeLatest } from "redux-saga/effects"
import { ActionCreators } from "redux-undo"
import { createAction } from "../../utils/redux"
import ActionTypes from "../../enums/ActionTypes"
import timelines from "./timelines"
import updateProjects from "./projects"
import operations from "./operations"
import timelineItems from "./timelineItems"

interface FilterRangeProps {
  payload: {
    fromDate: string
    toDate: string
    fetchTimelineData: boolean
  }
}

function* setFilterRangeTimeline({ payload }: FilterRangeProps) {
  if (payload.fetchTimelineData) {
    yield put(createAction(ActionTypes.TIMELINE_DATA_FETCH_REQUEST, { payload: omit(payload, ["fetchTimelineData"]) }))
  }
}

function* refetchTimelineData() {
  yield put(ActionCreators.clearHistory())
}

export default [
  ...timelines,
  ...updateProjects,
  ...operations,
  ...timelineItems,
  takeLatest(
    ActionTypes.UI_TIMELINE_SET_SHOWDATEFILTER_TIMELINE as unknown as TakeableChannel<unknown>,
    setFilterRangeTimeline
  ),
  takeLatest(ActionTypes.TIMELINE_DATA_FETCH_SUCCESS as unknown as TakeableChannel<unknown>, refetchTimelineData),
]
